import { render, staticRenderFns } from "./OrganizationsGridChip.vue?vue&type=template&id=dc74467c&scoped=true"
import script from "./OrganizationsGridChip.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationsGridChip.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationsGridChip.vue?vue&type=style&index=0&id=dc74467c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc74467c",
  null
  
)

export default component.exports